import { createContext, useContext } from 'react';
import type { ItemConfig } from '@pizza-roma/shared';

export interface PublicRestaurant {
  id: string;
  slug: string;
  name: string;
  currency: string;
  address: { line1?: string; city?: string; postalCode?: string; province?: string };
  description: string;
  phone: string;
  email: string;
  logoUrl: string;
  heroImageUrl: string;
  location: { lat: number; lng: number };
  hours: Record<string, { open: string; close: string; closed: boolean }>;
  openStatus: { open: boolean; todayLabel: string; opensAt?: string; closesAt?: string };
  acceptingOrders: boolean;
  deliveryEnabled: boolean;
  pickupEnabled: boolean;
  deliveryRadiusKm: number;
  deliveryFeeCents: number;
  minimumOrderCents: number;
  taxRatePercent: number;
  prepTimeMinutes: number;
  deliveryEstimate: { min: number; max: number };
  promo: { enabled: boolean; title: string; subtitle: string; itemId?: string };
}

export interface MenuItem {
  id: string;
  categoryId: string | null;
  name: string;
  description: string;
  basePriceCents: number;
  startingPriceCents: number;
  imageUrl: string | null;
  config: ItemConfig;
}

export interface Menu {
  categories: { id: string; name: string; icon: string }[];
  items: MenuItem[];
}

export const PublicCtx = createContext<{ restaurant: PublicRestaurant; menu: Menu } | null>(null);

export function usePublic() {
  const c = useContext(PublicCtx);
  if (!c) throw new Error('PublicCtx missing');
  return c;
}

/** Category illustration: first item of the category. */
export function categoryImage(menu: Menu, categoryId: string) {
  return menu.items.find((i) => i.categoryId === categoryId)?.imageUrl ?? '/food/pizza-margherita.svg';
}
